<template>
  <div>
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      message: 'welcome to ITSM'
    }
  },
  mounted () {
    this.$router.push({path: '/login'})
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 0.2rem;
  }
  a {
    color: #42b983;
  }
  .a{
    display: inline-block;
    height: 1rem;
    width: 1rem;
    background-color: gray;
  }
  .nav_bar{
    height: 0.92rem;
  }
  .swipe{
    padding-top: 0.92rem;
    height: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue